import { reactive } from 'vue';
import { Storage } from '@/util/storage';

class User {
  readonly data: { user?: any } = reactive({});

  constructor() {
    this.data.user = Storage.get('loginUser');
  }

  set(user: any) {
    this.data.user = user;
    Storage.set('loginUser', this.data.user);
  }

  del() {
    delete this.data.user;
    Storage.del('loginUser');
  }
}

export const user = new User();
